export const GIFTLY_CUSTOMER_NOT_EXISTS_ERROR = 'GIFTLY_CUSTOMER_404_ERROR';
export const GIFTLY_CUSTOMER_BLOCKED_BY_IP_OR_EMAIL = 'CUSTOMER_BAN_BY_IP_OR_EMAIL';
